/**
 * Check if a given string is formatted as a geoid (guid)
 *
 * @param value a string to check
 * @returns true if value is a valid geoid (guid)
 */
export const isGeoid = (value: string): boolean =>
  /^[0-9a-f-]{32,37}$/i.test(value); // Support guid, with or without dashes

/**
 * Check if a given string is formatted as a geohash
 *
 * @param value a string to check
 * @returns true if value is a valid geohash
 */
export const isGeohash = (value: string): boolean =>
  isPoiGeohash(value) || isCityGeohash(value);

export const isPoiGeohash = (value: string): boolean =>
  /^[\w]{7,9}$/i.test(value);

export const isCityGeohash = (value: string): boolean =>
  /^[\w]{6}$/i.test(value);
